import { useMemo, useState } from 'react'
import { FaMinusCircle, FaPlusCircle } from 'react-icons/fa'
import { Select } from '../../../styles/global'
import { Modal } from './Modal'
import { orderBoardsAsTree } from './format'
import { ActionButton, FieldRow, TabButton, TabsBar } from './styles'

function NewBoardModal({ boards, defaultParentId, onSave, onClose }) {
  const [name, setName] = useState('')
  const [parentId, setParentId] = useState(defaultParentId)

  function submit() {
    if (name.trim()) onSave({ name: name.trim(), parentId })
  }

  return (
    <Modal
      title="Novo quadro"
      onClose={onClose}
      footer={
        <>
          <ActionButton type="button" $variant="secondary" onClick={onClose}>
            Cancelar
          </ActionButton>
          <ActionButton type="button" disabled={!name.trim()} onClick={submit}>
            Adicionar quadro
          </ActionButton>
        </>
      }
    >
      <FieldRow>
        <label>
          Nome
          <input
            type="text"
            value={name}
            placeholder="Ex.: QDS - Quadro superior"
            onChange={(event) => setName(event.target.value)}
            onKeyDown={(event) => {
              if (event.key === 'Enter') submit()
            }}
          />
        </label>
        <label>
          Alimentado por
          <Select id="newBoardParentSelect" value={parentId} onChange={(event) => setParentId(event.target.value)}>
            {boards.map((board) => (
              <option key={board.id} value={board.id}>
                {board.name}
              </option>
            ))}
          </Select>
        </label>
      </FieldRow>
    </Modal>
  )
}

// Um quadro por aba, em ordem de árvore (os alimentados aparecem recuados após o quadro que os alimenta).
export function BoardTabs({ boards, activeBoardId, onSelect, onAdd, onRemove }) {
  const [isAdding, setIsAdding] = useState(false)
  const rows = useMemo(() => orderBoardsAsTree(boards), [boards])
  const activeBoard = boards.find((board) => board.id === activeBoardId)

  return (
    <>
      <TabsBar role="tablist" aria-label="Quadros">
        {rows.map(({ board, depth }) => (
          <TabButton
            key={board.id}
            type="button"
            role="tab"
            aria-selected={board.id === activeBoardId}
            $active={board.id === activeBoardId}
            $depth={depth}
            title={
              depth > 0 ? `Alimentado por ${boards.find((item) => item.id === board.parentId)?.name}` : 'Quadro raiz'
            }
            onClick={() => onSelect(board.id)}
          >
            {depth > 0 && '└ '}
            {board.name}
            <small>({board.circuits.length})</small>
          </TabButton>
        ))}
        <ActionButton type="button" $variant="secondary" onClick={() => setIsAdding(true)}>
          <FaPlusCircle style={{ verticalAlign: 'middle', marginRight: 6 }} />
          Novo quadro
        </ActionButton>
        <ActionButton
          type="button"
          $variant="secondary"
          disabled={!activeBoard || activeBoard.parentId === null}
          title={
            activeBoard?.parentId === null ? 'O quadro raiz não pode ser removido' : `Remover ${activeBoard?.name}`
          }
          onClick={() => onRemove(activeBoardId)}
        >
          <FaMinusCircle style={{ verticalAlign: 'middle', marginRight: 6 }} />
          Remover quadro
        </ActionButton>
      </TabsBar>
      {isAdding && (
        <NewBoardModal
          boards={boards}
          defaultParentId={activeBoardId}
          onClose={() => setIsAdding(false)}
          onSave={(data) => {
            onAdd(data)
            setIsAdding(false)
          }}
        />
      )}
    </>
  )
}
